import React from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { compose, withHandlers } from "recompose";
import { Grid, Typography, Divider, Button } from "@material-ui/core";
import {
  SUSPENDED_ACCESS,
  MANAGE_SUSPENDED_SECRETS,
  CREATED_AT,
  SUSPENDED_DATE,
  REACTIVATE,
  WEBHOOK_SNACKBAR_MESSAGES,
} from "../../../../../constants/strings";
import {
  reactivateWebhookSecretAction,
  removeSuspendedSecret,
} from "../../../../../features/webhooks/webhook.actions";
import { getSuspendedSecrets } from "../../../../../features/webhooks/webhook.selectors";
import { showSnackbar } from "../../../../../features/snackbar/snackbar.actions";
import InputWithTitle from "../../../../../components/InputWithTitle/InputWithTitle";
import { formatDate } from "../../../../../utils/timeFormater";

const SuspendedAccess = ({
  webhookType,
  suspendedSecrets,
  handleReactivateSecret,
}) => {
  return (
    <>
      <Divider />
      <Grid item xs={12}>
        <Typography variant="h6">{SUSPENDED_ACCESS}</Typography>
        <Typography variant="body2" color="textSecondary" gutterBottom>
          {MANAGE_SUSPENDED_SECRETS}
        </Typography>
      </Grid>

      {(() => {
        const secrets = suspendedSecrets
          ? suspendedSecrets.find((entry) => entry.type === webhookType)
              ?.suspendedSecrets || []
          : [];

        return (
          secrets.length > 0 && (
            <>
              <Grid item xs={12}>
                <Grid container spacing={2} alignItems="center">
                  <Grid item xs={12} md={2}>
                    <Typography variant="body2">{CREATED_AT}</Typography>
                  </Grid>
                  <Grid item xs={12} md={2}>
                    <Typography variant="body2">{SUSPENDED_DATE}</Typography>
                  </Grid>
                  <Grid item xs={12} md={6}></Grid>
                  <Grid item xs={12} md={2}></Grid>
                </Grid>
              </Grid>

              <Grid item xs={12}>
                <Divider />
              </Grid>

              {secrets.map((secret, index) => (
                <Grid
                  item
                  xs={12}
                  key={secret.secretId || index}
                  style={{ marginBottom: "16px" }}
                >
                  <Grid container spacing={2} alignItems="center">
                    <Grid item xs={12} md={2}>
                      <Typography variant="body2">
                        {formatDate(secret.createdAt, "dd/MM/yyyy")}
                      </Typography>
                    </Grid>
                    <Grid item xs={12} md={2}>
                      <Typography variant="body2">
                        {secret.suspendedAt
                          ? formatDate(secret.suspendedAt, "dd/MM/yyyy")
                          : "N/A"}
                      </Typography>
                    </Grid>
                    <Grid item xs={12} md={6}>
                      <InputWithTitle
                        input={{
                          value: secret.sharedSecret || "",
                          onBlur: () => {},
                          onChange: () => {},
                        }}
                        disabled
                      />
                    </Grid>
                    <Grid item xs={12} md={2}>
                      <Button
                        fullWidth
                        variant="contained"
                        color="primary"
                        onClick={() => handleReactivateSecret(secret)}
                      >
                        {REACTIVATE}
                      </Button>
                    </Grid>
                  </Grid>
                </Grid>
              ))}
            </>
          )
        );
      })()}
    </>
  );
};

SuspendedAccess.propTypes = {
  webhookType: PropTypes.string,
  suspendedSecrets: PropTypes.array,
  handleReactivateSecret: PropTypes.func,
  webhookConfig: PropTypes.object,
  setDirtyConfig: PropTypes.func,
  setConfig: PropTypes.func,
  accountNumber: PropTypes.string,
  businessId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

const mapStateToProps = (state) => ({
  suspendedSecrets: getSuspendedSecrets(state),
});

const mapDispatchToProps = (dispatch) => ({
  reactivateWebhookSecret: reactivateWebhookSecretAction,
  removeSuspendedSecret,
  dispatch,
});

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  withHandlers({
    handleReactivateSecret:
      ({
        dispatch,
        accountNumber,
        businessId,
        reactivateWebhookSecret,
        removeSuspendedSecret,
        webhookType,
        webhookConfig,
        setDirtyConfig,
      }) =>
      async (secret) => {
        try {
          await dispatch(
            reactivateWebhookSecret(
              accountNumber,
              secret.secretId,
              webhookType,
              businessId
            )
          );

          dispatch(removeSuspendedSecret(secret.secretId, webhookType));

          if (webhookConfig && setDirtyConfig) {
            const reactivatedSecret = {
              secretId: secret.secretId,
              sharedSecret: secret.sharedSecret,
              createdAt: secret.createdAt,
              inUse: false,
            };

            const existingSecrets = webhookConfig.secrets || [];
            const updatedSecrets = [...existingSecrets, reactivatedSecret];

            const updatedWebhookConfig = {
              ...webhookConfig,
              secrets: updatedSecrets,
            };

            setDirtyConfig(updatedWebhookConfig);
          }

          dispatch(
            showSnackbar({
              message: WEBHOOK_SNACKBAR_MESSAGES.SECRET_REACTIVATED_SUCCESS,
              variant: "success",
            })
          );
        } catch (error) {
          dispatch(
            showSnackbar({
              message: WEBHOOK_SNACKBAR_MESSAGES.SECRET_REACTIVATE_FAILED,
              variant: "error",
            })
          );
        }
      },
  })
)(SuspendedAccess);
